// 坐标轴操作
function Axis (canvasElement) {
    const ctx = canvasElement.getContext("2d");
    // ctx.scale(0.5, 0.5)

    let cssX = canvasElement.width / 2
    let cssY = canvasElement.height / 2

    let changeCssXY = false, mousedownEvent = undefined
    canvasElement.addEventListener('mousedown', (e) => {
        console.log('canvas mouseDown', e)
        changeCssXY = true
        mousedownEvent = e
    })
    canvasElement.addEventListener('mousemove', (e) => {
        if (changeCssXY) {
            let scale = ctx.getTransform().a
            cssX += (e.screenX - mousedownEvent.screenX) / scale
            cssY += (e.screenY - mousedownEvent.screenY) / scale
            mousedownEvent = e
        }
    })
    canvasElement.addEventListener('mouseout', () => {
        changeCssXY = false
    })
    canvasElement.addEventListener('mouseup', () => {
        changeCssXY = false
    })
    canvasElement.addEventListener('wheel', (e) => {
        console.log('keydown', e)
        const delta = Math.sign(e.deltaY)
        if (delta < 0)
            ctx.scale(1.1, 1.1)
        else
            ctx.scale(0.9, 0.9)
    })

    return {
        ctx: ctx,
        w: canvasElement.width,
        h: canvasElement.height,

        _fpsTime: undefined,
        fps: 0,
        _countFps: 0,
        clear () {
            let matrix = ctx.getTransform()
            let w = this.w, h = this.h
            if (matrix.a < 1) {
                w = this.w / matrix.a
                h = this.h / matrix.a
            }
            ctx.clearRect(0, 0, w, h);
        },
        drawFps () {
            if (!this._fpsTime)
                this._fpsTime = performance.now();
            let now = performance.now()
            // ctx.fillText('now ' + now, 30, 30)
            // ctx.fillText('now - fpsTime ' + (now - fpsTime), 40, 40)
            if (now - this._fpsTime > 1000) {
                this.fps = this._countFps
                this._countFps = 0
                this._fpsTime = performance.now()
            } else
                this._countFps++
            ctx.fillStyle = "#0095DD";
            let a = ctx.getTransform().a
            ctx.font = 10 / a + "px Verdana"
            ctx.fillText('FPS ' + this.fps, 10 / a, 10 / a)
        },

        _x (beforeX) {
            return cssX + beforeX
        },
        _y (beforeY) {
            return cssY - beforeY
        },
        line (startX, startY, endX, endY, strokeStyle = 'black') {
            ctx.beginPath()
            ctx.moveTo(this._x(startX), this._y(startY))
            ctx.lineTo(this._x(endX), this._y(endY))
            ctx.lineWidth = 0.33
            ctx.strokeStyle = strokeStyle
            ctx.stroke()
            ctx.closePath()
        },
        // 画xy轴
        drawXY () {
            this.line(0, 0, this.w, 0, 'green')
            this.line(0, 0, 0, this.h, 'red')
        },
        debuggerPoint (x, y) {
            ctx.beginPath()
            ctx.arc(this._x(x), this._y(y), 1, 0, 2 * Math.PI);
            ctx.stroke()
            ctx.closePath()
        },
        // eslint-disable-next-line no-unused-vars
        _drawG (x, y, x1, y1, i, j, G02 = true, lineColor) {
            // x	圆的中心的 x 坐标。
            // y	圆的中心的 y 坐标。
            // r	圆的半径。
            // sAngle	起始角，以弧度计。（弧的圆形的三点钟位置是 0 度）。
            // eAngle	结束角，以弧度计。
            // counterclockwise	可选。规定应该逆时针还是顺时针绘图。False = 顺时针(默认)，true = 逆时针。
            // context.arc(x,y,r,sAngle,eAngle,counterclockwise);
            x = this._x(x)
            y = this._y(y)
            x1 = this._x(x1)
            y1 = this._y(y1)
            let arcX = x + i,
                arcY = y - j,
                sAngle = Math.atan2((y - arcY), (x - arcX)),
                eAngle = Math.atan2((y1 - arcY), (x1 - arcX))
            let dx = Math.abs(arcX - x);
            let dy = Math.abs(arcY - y);
            let r = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
            ctx.strokeStyle = lineColor
            ctx.beginPath()
            ctx.arc(arcX, arcY, r, sAngle, eAngle, !G02);
            ctx.stroke()
            ctx.closePath()
        },
        drawG02 (x, y, x1, y1, i, j, lineColor) {
            this._drawG(x, y, x1, y1, i, j, true, lineColor)
        },
        drawG03 (x, y, x1, y1, i, j, lineColor) {
            this._drawG(x, y, x1, y1, i, j, false, lineColor)
        }
    }
}

export default Axis